// extracted by mini-css-extract-plugin
module.exports = {"bio":"style-module--bio--2W1Gk","profileImage":"style-module--profileImage--3G3HA","bioLinkText":"style-module--bioLinkText--2mKUS"};